import { Quote } from "lucide-react";

const PARAGRAPHS = [
  "Jayaram Das was born into a humble farmer's family, where he learned the values of hard work, honesty, and compassion from an early age. Despite rising to prominence, he has remained deeply grounded and connected to ordinary people, earning respect as a truly down-to-earth leader.",
  "During the COVID-19 pandemic, Jayaram Das became a pillar of support for countless families. He organized relief efforts, distributed food and essentials, provided financial assistance, and stood beside those struggling during one of the most difficult times in recent history. His humanitarian work brought hope to many who felt helpless and forgotten.",
  "Driven by a strong commitment to social welfare, he has launched numerous schemes to support the needy, especially people facing financial hardship. He is also a dedicated legal advisor and a renowned advocate. Through his charitable initiatives, he has funded schools, supported educational programs, and contributed to causes focused on healthcare and community development.",
  "Jayaram Das also founded his own NGO and SHG, dedicated to helping underprivileged communities through welfare programs, relief activities, and social support initiatives. Believing that leadership should serve the people, he established his own political party with a mission to uplift society, support citizens in their daily struggles, and create opportunities for those in need.",
  "His journey from a farmer's background to becoming a respected humanitarian and public leader reflects a life built on service, humility, and dedication to humanity. Today, Jayaram Das continues to inspire people through his vision of compassion, equality, and meaningful change.",
];

export default function Founder() {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="relative py-20 md:py-32 bg-sand"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          {/* Left — Identity card */}
          <aside className="md:col-span-4 md:sticky md:top-28 self-start">
            <p className="overline mb-6">Founder</p>

            <div className="relative bg-cream border border-line p-8 md:p-10">
              {/* Monogram */}
              <div
                className="w-28 h-28 md:w-32 md:h-32 rounded-full bg-forest text-cream flex items-center justify-center mb-6 font-serif text-5xl md:text-6xl tracking-tight"
                data-testid="founder-monogram"
              >
                JD
              </div>

              <h3 className="font-serif text-4xl md:text-5xl text-ink leading-none mb-3">
                Jayaram Das
              </h3>
              <p className="font-serif italic text-lg text-terracotta mb-6 leading-snug">
                A life dedicated to humanity
              </p>

              <div className="divider-rule mb-6" />

              <ul className="space-y-3 text-sm">
                <Tag label="Humanitarian" />
                <Tag label="Advocate &amp; Legal Advisor" />
                <Tag label="Founder — NGO &amp; SHG" />
                <Tag label="Public leader" />
              </ul>
            </div>
          </aside>

          {/* Right — Biography */}
          <div className="md:col-span-8">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-ink leading-tight text-balance">
              From a farmer's <em className="italic text-terracotta">field</em> to a life of <em className="italic text-forest">service</em>.
            </h2>

            <div className="mt-8 flex items-start gap-3 text-graphite">
              <Quote
                size={22}
                strokeWidth={1.5}
                className="text-mustard flex-shrink-0 mt-1"
              />
              <p className="font-serif italic text-xl md:text-2xl text-ink leading-snug">
                Leadership should serve the people.
              </p>
            </div>

            <div className="mt-10 space-y-6 text-graphite md:text-lg leading-relaxed">
              {PARAGRAPHS.map((p, i) => (
                <p
                  key={i}
                  data-testid={`founder-para-${i + 1}`}
                  className="border-l-2 border-line pl-6 hover:border-terracotta transition-colors"
                >
                  {p}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Tag({ label }) {
  return (
    <li className="flex items-center gap-3 text-graphite">
      <span className="w-1.5 h-1.5 rounded-full bg-mustard" />
      <span dangerouslySetInnerHTML={{ __html: label }} />
    </li>
  );
}
